<template>
	<div class="w-100 h-100 d-flex flex-row align-center">
		<template v-if="isDesktopDevice">



			<div class="header__nav-container">

				<router-link to="/">
					<img :src="AppConfigs.staticImages.LOGO" height="40" class="me-auto" />
				</router-link>
				<HeaderNavigationLinks />
				<WheelLaunchButton />
				<NotificationBell />
				<EarningsButton />
				<ProfileMenuList></ProfileMenuList>

			</div>




		</template>
		<template v-else>




			<ProfileMenuList></ProfileMenuList>
			<v-spacer></v-spacer>
			<WheelLaunchButton />
			<EarningsButton class="mx-2" />
			<NotificationBell />




		</template>
	</div>
</template>



<script setup>

import { AppConfigs } from "@/app.configs";
import { isDesktop } from "@/utils/utils";
import EarningsButton from './EarningsButton.vue';
import ProfileMenuList from "./Profile-Menu-List.vue";
import NotificationBell from '../Notification/Notification-Bell.vue';
import HeaderNavigationLinks from "./Header-Navigation-Links.vue";
import WheelLaunchButton from "@/components/SpinTheWheel/WheelLaunchButton.vue";

const isDesktopDevice = isDesktop();

</script>